/**
 * Form Table 에서 Row 를 감싸고 있는 모델입니다.
 */
import tableUtilManager from "@/assets/plugins/mps-form-table/plugins/common/util/table-util-manager";

class TrModel {
    _item;
    _visible = true;
    _checked = false;
    _selected = false;
    _expanded = false;
    _key = tableUtilManager.getUniqueId();

    constructor(item) {
        this._item = item;
    }

    get raw() {
        return this._item;
    }

    get key() {
        return this._key;
    }

    get visible() {
        return this._visible;
    }

    set visible(visible) {
        return this._visible = visible;
    }

    set checked(bool) {
        this._checked = bool;
    }

    get checked() {
        return this._checked;
    }

    set selected(bool) {
        this._selected = bool;
    }

    get selected() {
        return this._selected;
    }

    toggleExpanded() {
        this._expanded = !this._expanded;
    }

    get expanded() {
        return this._expanded;
    }

    set expanded(expanded) {
        this._expanded = expanded;
    }
}

export default TrModel;
